import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Typography, Divider, Grid } from '@material-ui/core';
import PageTitle from '../../components/ui/PageTitleUI';
import ButtonUI from '../../components/ui/ButtonUI';
import { useTranslation } from 'react-i18next';
import {
    Search as SearchIcon,
    BackspaceOutlined as BackspaceOutlinedIcon
} from '@material-ui/icons';
import { useAuth } from '../../hooks/auth';
import { useForm } from 'react-hook-form';
import DateField from '../../components/Form/Date';
import { useStyles } from '../../utils/DefaultStyles';
import SelectSupplier from '../../components/Form/SelectSupplier';
import ReportApi from '../../services/ReportApi';
import permissions from '../../utils/Permissions';
import Select from '../../components/Form/Select';
import * as Yup from 'yup'

const BillingRecordReport: React.FC = () => {
    const classes = useStyles();
    const { user, hasPermission } = useAuth();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("Reports");
    const { t: tVal } = useTranslation("Validation");
    const history = useHistory();

    useEffect(() => {
        if (!hasPermission(permissions.REPORTS.BillingRecord))
            history.replace('/NoPermission');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, user]);

    
    //Campos do Form
    interface IFormPanel {
        startDate: Date | null;
        endDate: Date | null;
        suppliers: any;
        renderType: any;
    }

    //Metodos do form:
    const { handleSubmit, reset, control, clearErrors, setError } = useForm<IFormPanel>({
        defaultValues: {
            startDate: null,
            endDate: null,
            suppliers: [],
            renderType: {code: '2', label: 'Excel'}
        }
    });

    useEffect(() => {
    }, []);
    

    const formValidation = async (data: any) => {
        var result = false
        clearErrors();

        try {
            const schema = Yup.object().shape({              
                startDate: Yup.date().nullable().typeError(tVal("formatDate")),
                endDate: Yup.date().nullable().typeError(tVal("formatDate"))
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            result = true
        }
        catch (err) {

            var errors: string[] = []

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {

                    if (errors.filter(element => element.includes(error.message)).length === 0)
                        errors.push(error.message)

                    setError(error.path?.split('.')[0] as "startDate" | "endDate"
                    , { message: error.message });
                })
            }

            result = false;
        }

        return result
    }

    const onSubmit = async (data: any) => {
        
        var validForm = await formValidation(data)
        if (!validForm)
            return;
        
        data.supplierNames = data.suppliers.map((x:any) => (x.code + ' - ' + x.name));
        data.supplierIds = data.suppliers.map((x:any) => (x.code));
        data.companyId = user.company.companyID;
        data.userName = user.name;
        data.renderType = data.renderType.code;

        ReportApi.printBillingRecord(data);
    };

    const cleanFilters = () => {
        reset();
    };

    return (
        <Container maxWidth={false} component="main">
            <PageTitle title={t("pageTitle") + t("billingRecord.pageTitle")} />

            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={handleSubmit(onSubmit)}  >

                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleParameters")}
                                </Typography>

                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI onClick={() => cleanFilters()} startIcon={<BackspaceOutlinedIcon />}>{_t("clean")}</ButtonUI>
                                <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{_t("export")}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>

                            <Grid item xs={3}>
                                <SelectSupplier
                                    label={t("billingRecord.supplier")} 
                                    name="suppliers" 
                                    control={control} 
                                    multiple={true}
                                    fullWidth
                                    // style={{width: '100%'}}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <DateField label={t("billingRecord.startDate")} name="startDate" control={control} InputLabelProps={{shrink:true}} fullWidth/>
                            </Grid>

                            <Grid item xs={2}>
                                <DateField label={t("billingRecord.endDate")} name="endDate" control={control} InputLabelProps={{shrink:true}} fullWidth/>
                            </Grid>


                            <Grid item xs={1}>
                                <Select
                                    label={_t("reportExportType")} 
                                    name="renderType"
                                    control={control} 
                                    options={[{code: '2', label: 'Excel'}, {code: '1', label: 'PDF'}]}
                                    style={{width: '100%'}}/>
                            </Grid>

                            <Grid item xs={4}>
                            </Grid>

                        </Grid>
                    </form>

                </div>
            </div>
        </Container>
    )
}
export default BillingRecordReport;
